import React, { useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { Link, useNavigate, useParams } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { useQuery } from "@tanstack/react-query";

import { useSelector } from "react-redux";

import { Skeleton } from "@mui/material";
import dayjs from "dayjs";
// import { Table } from "antd";
import { getStaffDetails } from "../../connections/getStaffDetails";
import { deleteStaff } from "../../connections/deleteStaff";
import { toast } from "react-toastify";
import { imagesend } from "../imagepath";
import { formatDateTime } from "../../utils/constant/constant";

const ShowStaff = () => {
  const {
    user: { user },
  } = useSelector((store) => store);
  const { id } = useParams();
  const [deleteId, setDeleteId] = useState(null);
  const navigate = useNavigate();
  const { data: getStaffDetailData, isLoading } = useQuery({
    queryKey: ["getStaffDetails", id],
    queryFn: () => getStaffDetails(user?.token, id),
    enabled: !!id,
    // staleTime: Infinity, // Keep the data fresh indefinitely

    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnReconnect: false, // Don't refetch when reconnecting
  });
  const handleDeleteStaff = async (e) => {
    e.preventDefault();

    try {
      const data = await deleteStaff(user?.token, deleteId);
      if (data.status.status === "SUCCESS") {
        toast.success("Staff Deleted Successfully");
        navigate("/admin/staff_list");
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  // const columns = [
  //   {
  //     title: "Id",
  //     dataIndex: "id",
  //   },
  //   {
  //     title: "Uid",
  //     dataIndex: "uid",
  //     render: (text, record) => (
  //       <>
  //         {text}
  //         <div style={{ color: "green" }}>
  //           Username : {record?.account_uid ? record?.account_uid : "Empty"}
  //         </div>
  //       </>
  //     ),
  //   },
  //   {
  //     title: "First Name",
  //     dataIndex: "first_name",
  //   },
  //   {
  //     title: "Last Name",
  //     dataIndex: "last_name",
  //   },
  //   {
  //     title: "Email",
  //     dataIndex: "email",
  //   },
  //   {
  //     title: "Mobile",
  //     dataIndex: "mobile",
  //   },
  //   {
  //     title: "Active",
  //     dataIndex: "active",
  //     render: (text) => (
  //       <div>
  //         {text === true && (
  //           <span className="custom-badge status-green">{"Yes"}</span>
  //         )}
  //         {text === false && (
  //           <span className="custom-badge status-pink">{"NO"}</span>
  //         )}
  //         {text === null && (
  //           <span className="custom-badge status-pink">{"NO"}</span>
  //         )}
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "Roles",
  //     dataIndex: "roles",
  //     render: (role) => (
  //       <span
  //         style={{
  //           whiteSpace: "normal",
  //           wordBreak: "break-word",
  //           maxWidth: "250px",
  //           display: "block",
  //           overflow: "hidden",
  //           textOverflow: "ellipsis",
  //         }}
  //       >
  //         {role?.length > 0 &&
  //           role.map((el, idx) => (
  //             <span key={idx}>
  //               {el?.name}
  //               {idx < role.length - 1 && ","}
  //             </span>
  //           ))}
  //       </span>
  //     ),
  //   },
  //   {
  //     title: "Created At",
  //     dataIndex: "created_at",
  //     //   sorter: (a, b) => a.ConsultingDoctor.length - b.ConsultingDoctor.length,
  //     render: (date) => (
  //       <>
  //         {" "}
  //         {date}
  //       </>
  //     ),
  //   },
  //   {
  //     title: "Updated At",
  //     dataIndex: "updated_at",
  //     //   sorter: (a, b) => a.Treatment.length - b.Treatment.length,
  //     render: (date) => (
  //       <>
  //         {" "}
  //         {date}
  //       </>
  //     ),
  //   },
  // ];
  return (
    <>
      <Header />
      <Sidebar activeClassName="staff-list" />
      <>
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item active">
                      <Link to={-1}>Staff Details</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">{id}</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table show-entire">
                  <div className="card-body">
                    {/* content Header */}
                    <div className="page-table-header mb-2">
                      <div className="row align-items-center">
                        <div className="col">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                            className="doctor-table-blk"
                          >
                            <h3>Staff Details</h3>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                              className="doctor-search-blk"
                            >
                              <button
                                className="btn btn-sm btn-primary d-flex align-items-center justify-content-center"
                                style={{
                                  minWidth: "100px",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                }}
                                onClick={() => {
                                  navigate("/admin/edit_staff", {
                                    state: getStaffDetailData,
                                  });
                                }}
                              >
                                <i className="far fa-edit me-2" />
                                Edit
                              </button>

                              <button
                                className="btn btn-sm btn-danger d-flex align-items-center justify-content-center"
                                style={{
                                  minWidth: "100px",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                }}
                                data-bs-toggle="modal"
                                data-bs-target="#delete_patient"
                                onClick={() => {
                                  setDeleteId(getStaffDetailData?.id);
                                }}
                              >
                                <i className="fa fa-trash-alt me-2" />
                                Delete
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {isLoading ? (
                      <div>
                        <Skeleton
                          variant="rectangular"
                          width="100%"
                          height={430} // Same height as your chart
                        />
                      </div>
                    ) : (
                      <div className="content-details">
                        <div className="col-lg-12">
                          <div className="card-box">
                            <div className="card-block">
                              <ul className="personal-info">
                                <li className="pb-1">
                                  <span className="title">Id:</span>
                                  <span className="text">
                                    {getStaffDetailData?.id || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Uid:</span>
                                  <span className="text">
                                    {getStaffDetailData?.uid || "N/A"}
                                    <div style={{ color: "green" }}>
                                      Username :{" "}
                                      {getStaffDetailData?.account_uid ||
                                        "Empty"}
                                    </div>
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">First Name:</span>
                                  <span className="text">
                                    {getStaffDetailData?.first_name || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Last Name:</span>
                                  <span className="text">
                                    {getStaffDetailData?.last_name || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Email:</span>
                                  <span className="text">
                                    {getStaffDetailData?.email || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Mobile:</span>
                                  <span className="text">
                                    {getStaffDetailData?.mobile || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Active:</span>
                                  <span className="text">
                                    {getStaffDetailData?.active === true && (
                                      <span className="custom-badge status-green">
                                        Yes
                                      </span>
                                    )}
                                    {getStaffDetailData?.active === false && (
                                      <span className="custom-badge status-pink">
                                        No
                                      </span>
                                    )}
                                    {getStaffDetailData?.active === null && (
                                      <span className="custom-badge status-pink">
                                        No
                                      </span>
                                    )}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Roles:</span>
                                  <span className="text">
                                    {getStaffDetailData?.roles?.length > 0 &&
                                      getStaffDetailData.roles.map(
                                        (el, idx) => (
                                          <span key={idx}>
                                            {el?.name}
                                            {idx <
                                              getStaffDetailData.roles.length -
                                                1 && ","}
                                          </span>
                                        )
                                      )}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Created At:</span>
                                  <span className="text">
                                    {getStaffDetailData?.created_at
                                      ? formatDateTime(
                                          getStaffDetailData?.created_at
                                         
                                        )
                                      : "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Updated At:</span>
                                  <span className="text">
                                    {getStaffDetailData?.updated_at
                                      ? formatDateTime(
                                          getStaffDetailData?.updated_at,
                                         
                                        )
                                      : "N/A"}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      // <div className="table-responsive">
                      //   <Table
                      //     columns={columns}
                      //     dataSource={[getStaffDetailData]}
                      //     pagination={false}
                      //     scroll={{ x: "max-content" }}
                      //   />
                      // </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="delete_patient"
          className="modal fade delete-modal"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body text-center">
                <img src={imagesend} alt="#" width={50} height={46} />
                <h3>Are you sure want to delete this ?</h3>
                <div className="m-t-20">
                  {" "}
                  <Link
                    to="#"
                    className="btn btn-white me-2"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </Link>
                  <button
                    onClick={handleDeleteStaff}
                    type="submit"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default ShowStaff;
